// controllers
import { ProductController } from "controllers";

// helper
import { didReceiveProduct, updateProductAndBox, wantsAgain } from "./helper";

const productAddNewFunction = async ({ barcodes, barcode, customer, country } = {}) => {

    if (!customer) {
        throw new Error('Please select a customer first.')
    }

    const product = await ProductController.getBarcode(barcode, country);

    if (!product) {
        throw new Error(
            [
                'ERROR:',
                'This barcode is not registered in the system.',
                'If it is not a typo, please bring it to Incoming Goods URGENTLY!'
            ].join(' ')
        );
    }

    if (didReceiveProduct(customer, product)) {
        // should be displayed as warning
        const wanted = await wantsAgain(customer, product);
        if (!wanted) {
            throw new Error('This user previously received this item or the same model.');
        }
    }

    const isExist = barcodes.some((p) => p.barcode === barcode);
    if (isExist) {
        // should be displayed as warning
        throw new Error('This item is already added to the current list.');
    }

    if (product.status === "missing") {
        try {
            await updateProductAndBox(product);
        } catch (error) {
            // should be displayed as warning
            throw new Error('Please try again. Something went wrong.');
        }
    }

    if (['at_customer', 'kept'].includes(product.status)) {
        // should be displayed as warning
        throw new Error('This garment already in another box for another customer.');
    }

    if (product.status === 'reserved' && customer.id !== product.currentUser) {
        // should be displayed as warning
        throw new Error('This product is reserved for another customer.');
    }

    if (product.excluded_customer === customer.email) {
        throw new Error('The current user cannot receive this item because she donated it.');
    }

    return product;
};

export { productAddNewFunction };
